import React from 'react';
import PropTypes from 'prop-types';
import * as styles from '../PackageItem.scss';

const PublisherPackageDetails = props => (
  <div className={styles.publisherPackage}>
    <div className={styles.description}>
      <div className={styles.publisherPackageTitle}>{props.translate(`${props.packageType}AdTitle`)}</div>
      <div>{props.translate(`${props.packageType}AdDescription`)}</div>
    </div>
    <div className={styles.publisherPromotionPeriod}>
      {props.translate('promotionPeriod').replace('%s', props.selectedPeriod)}
    </div>
    {props.requiredMessage && (
      <div className={styles.requiredMessage}>{props.requiredMessage}</div>
    )}
  </div>
);

PublisherPackageDetails.propTypes = {
  translate: PropTypes.func,
  packageType: PropTypes.string,
  selectedPeriod: PropTypes.number,
  requiredMessage: PropTypes.oneOfType([PropTypes.func, PropTypes.bool])
};

export default PublisherPackageDetails;
